import { createSlice } from "@reduxjs/toolkit"

export const validationsSlice = createSlice({
  name: "validations",
  initialState: {
    certificateValidation: false,
    showModalInvalidCertificado: false,
    showModalEmpresaCertificado: false,
  },
  reducers: {
    setCertificadoValidation(state, { payload }) {
      state.certificateValidation = payload
    },
    setShowModalInvalidCertificado(state, { payload }) {
      state.showModalInvalidCertificado = payload
    },
    setShowModalEmpresaCertificado(state, { payload }) {
      state.showModalEmpresaCertificado = payload
    },
  },
})

export const {
  setCertificadoValidation,
  setShowModalInvalidCertificado,
  setShowModalEmpresaCertificado,
} = validationsSlice.actions
